import { render, staticRenderFns } from "./GeodisBanner.vue?vue&type=template&id=610c7585"
import script from "./GeodisBanner.vue?vue&type=script&lang=js"
export * from "./GeodisBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports